<template>
  <v-container v-if="file">
    <toolbar mode="file" :item="file" @clone="onClone" @delete="onDelete">
      <ax-button 
        icon="mdi-arrow-down"
        tooltip="Download"
        :disabled="!isOwner(file)"
        @clicked="onDownload"
      />
      <ax-button
        icon="mdi-api"
        tooltip="Copy APIs"
        :disabled="file.status !== 'SUCCESS'"
        @clicked="onCopyApis"
      />
      <ax-button
        confirm
        icon="mdi-refresh"
        tooltip="Refresh"
        title="Reload data"
        subtitle="This will connect to the original database to download updated data and replace existing data."
        @confirmed="onUpdate"
        :disabled="!file.connection || file.status == 'PENDING'"
      ></ax-button>
    </toolbar>
    <v-card flat>
      <v-tabs v-model="tab">
        <v-tab href="#data">Data</v-tab>
        <v-tab href="#info">Info</v-tab>
        <!-- <v-tab href="#logs">Logs</v-tab> -->
        <v-tab href="#details">Details</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <v-tab-item value="data">
          <frame-head :items="head" @load="onLoad" />
        </v-tab-item>
        <v-tab-item value="info">
          <frame-info :items="info" />
        </v-tab-item>
        <!-- <v-tab-item value="logs">
          <v-card-text>
            <pre>{{ file.history }}</pre>
          </v-card-text>
        </v-tab-item> -->
        <v-tab-item value="details">
          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Name</v-col>
              <v-col>
                <template v-if="file.file">
                  {{ file.file.name }} ({{ file.file.size | byteFormat }})
                </template>
                <ax-status v-else :uuid="file.uuid" :status="file.status" />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Owner</v-col>
              <v-col>{{ file.owner.name }}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Created</v-col>
              <v-col>{{ file.created_at | dateFormat("LL LT") }} ({{ file.created_at | dateFormat }})</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Updated</v-col>
              <v-col>{{ file.updated_at | dateFormat("LL LT") }} ({{ file.updated_at | dateFormat }})</v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import AxButton from "@/components/button"
import frameHead from "@/components/head"
import frameInfo from "@/components/info"
import toolbar from "@/components/toolbar"
import Files from "@/api/files"
export default {
  name: "File",
  components: {
    frameHead,
    frameInfo,
    toolbar,
    AxButton
  },
  data() {
    return {
      file: null,
      head: {
        data: [],
        schema: {},
      },
      info: {
        data: [],
        schema: {}
      },
      headLoaded: false,
      headLoading: false
    }
  },
  created() {
    Files.retrieve(this.$route.params.uuid).then(response => this.file = response.data)
    Files.info(this.$route.params.uuid).then(response => this.info = typeof response.data == "string" ? JSON.parse(response.data) : response.data)
  },
  mounted() {
    this.onLoad()
  },
  computed: {
    tab: {
      set (tab) {
        this.$router.replace({ hash: tab })
      },
      get () {
        return this.$route.hash.replace('#', '')
      }
    },
  },
  methods: {
    onLoad() {
      if (this.headLoaded || this.headLoading) {
        return
      }
      
      this.headLoading = true
      Files.head(this.$route.params.uuid, this.head.data.length)
        .then((response) => {
          let head = typeof response.data == "string" ? JSON.parse(response.data) : response.data
          if (head.data && head.data.length > 0) {
            if (this.head.data.length === 0) {
              this.$set(this.head, 'data', head.data)
            } else {
              this.head.data.push(...head.data)
            }
            if (head.schema && Object.keys(head.schema).length > 0) {
              this.$set(this.head, 'schema', head.schema)
            }
            if (head.data.length < 50) {
              this.headLoaded = true
            }
          } else {
            this.headLoaded = true
          }
        })
        .finally(() => {
          this.headLoading = false
        })
    },
    onUpdate() {
      Files.refresh(this.$route.params.uuid).then(response => this.notify(response.data))
    },
    onDelete() {
      Files.destroy(this.$route.params.uuid).then(response => {
        this.notify('File deleted')
        this.$router.push({ name: 'fileList' })
      })
    },
    onDownload() {
      Files.download(this.$route.params.uuid).then(response => {
        let csv = response.data
        var downloadLink = document.createElement("a")
        var blob = new Blob(["\ufeff", csv])
        var url = URL.createObjectURL(blob)
        downloadLink.href = url
        downloadLink.download = `${this.$route.params.uuid}.csv` //Name the file here
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
      })
    },
    onClone(){
      Files.clone(this.$route.params.uuid).then(response => {
        this.notify('File cloned')
        this.$router.push({ name: 'fileList' } )
      })
    },
    onCopyApis() {
      Files.apis(this.$route.params.uuid).then(response => {
        const apis = response.data
        if (apis && apis.length > 0) {
          const apisText = apis.join('\n')
          navigator.clipboard.writeText(apisText).then(() => {
            this.notify(`Copied ${apis.length} APIs to clipboard`)
          }).catch(err => {
            this.notify('Failed to copy to clipboard')
          })
        } else {
          this.notify('No APIs found')
        }
      }).catch(err => {
        this.notify('Failed to retrieve APIs')
      })
    }
  }
}
</script>
